import { computed, Injectable, signal } from '@angular/core';

interface DcaSignalState {
  isDcaShown: boolean;
  isDcaExpanded: boolean;
}

@Injectable({ providedIn: 'root' })
export class DcaStore {
  private state = signal<DcaSignalState>({
    isDcaShown: false,
    isDcaExpanded: false,
  });

  readonly isDcaShown = computed(() => {
    return this.state().isDcaShown;
  });

  readonly isDcaExpanded = computed(() => {
    return this.state().isDcaExpanded;
  });

  readonly isDcaMaximized = computed(() => {
    const state = this.state();
    return state.isDcaShown && state.isDcaExpanded;
  });

  showDca() {
    this.state.update((state) => ({
      ...state,
      isDcaShown: true,
    }));
  }

  hideDca() {
    this.state.update((state) => ({
      ...state,
      isDcaShown: false,
      isDcaExpanded: false, // Auto-collapse when hiding
    }));
  }

  expandDcaWithMaximize() {
    this.state.update((state) => ({
      ...state,
      isDcaShown: true,
      isDcaExpanded: true,
    }));
  }

  collaspeDcaExpansion() {
    this.state.update((state) => ({
      ...state,
      isDcaExpanded: false,
    }));
  }

  toggleDcaExpansion() {
    this.state.update((state) => ({
      ...state,
      isDcaExpanded: !state.isDcaExpanded,
    }));
  }

  toggleDca() {
    this.state.update((state) => ({
      ...state,
      isDcaShown: !state.isDcaShown,
    }));
  }

  toggleDcaWithExpansion() {
    this.state.update((state) => ({
      ...state,
      isDcaShown: !state.isDcaShown,
      isDcaExpanded: state.isDcaShown ? false : true, // Expand when showing, collapse when hiding
    }));
  }

  reset() {
    this.state.set({
      isDcaShown: false,
      isDcaExpanded: false,
    });
  }
}
